export class FileStorage {
  id?: string;
  key?: string;
  name?: string;
  url?: string;
  thumbnailUrl?: string;
  size?: number;
  type?: string;

  source?: string;
  path?: string;

  file?: File;

  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;

  constructor(file?: File) {
    this.file = file;
  }
}
